export default (_elId) => {
    return `
<div class="player-vod"><div class="vod-embed" id="${_elId}"></div></div>

<div class="player-controlbar-wapper">
    <div class="player-controlbar">
        <div class="controlbar-buttons"></div>
        <span class="controlbar-time"></span>
        <div class="controlbar-progress"></div>
    </div>

    <div class="bg-triangle-medium is-double">
        <div class="triangle"></div>
        <div class="triangle"></div>
        <div class="triangle"></div>
    </div>
    <div class="bg-triangle-medium is-double">
        <div class="triangle"></div>
        <div class="triangle"></div>
        <div class="triangle"></div>
    </div>
</div>
<div class="player-info"></div>
<a href="" class="player-recommend ani-swing">추천영상</a>`;
};